var _excluded = ["action", "value"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import cx from 'classnames';
import React, { useCallback } from 'react';
import { useCssInJs, wrapReactionHook } from "../../hooks";
import { useAction } from "../../hooks/useAction";
import { Text } from "../Text";
import { genLinkStyles } from "./styles";
export var Link = wrapReactionHook(function (props) {
  var action = props.action,
    _props$value = props.value,
    value = _props$value === void 0 ? '点击跳转' : _props$value,
    rest = _objectWithoutProperties(props, _excluded);
  var prefix = 'form-link';
  var _useCssInJs = useCssInJs({
      prefix: prefix,
      styleFun: genLinkStyles
    }),
    wrapSSR = _useCssInJs.wrapSSR,
    hashId = _useCssInJs.hashId;
  var processAction = useAction();
  var onClick = useCallback(function () {
    if (action) {
      processAction(action);
    }
  }, [action]);
  return wrapSSR( /*#__PURE__*/React.createElement(Text, _extends({}, rest, {
    onClick: onClick,
    className: cx(prefix, hashId),
    value: value
  })));
});